<template>
<div>
    <v-text-field
        label="Alert Sound"
        :value="alert_sound_label"
        disabled
    />

    <v-text-field
        label="Text personal device when a new conversation starts"
        :value="profile.employee_account.personal_notification_settings.text_personal_device_on_new_conversation == true ? 'Yes' : 'No' "
        disabled
    />

    <v-text-field
        label="Text personal device when an idle conversation resumes"
        :value="profile.employee_account.personal_notification_settings.text_personal_device_on_new_conversation == true ? 'Yes' : 'No' "
        disabled
    />

    <v-text-field
        label="Text personal device when a voicemail is left"
        :value="profile.employee_account.personal_notification_settings.text_personal_device_on_new_voicemail == true ? 'Yes' : 'No' "
        disabled
    />

    

    <v-text-field
        label="Time after which a conversation is marked as idle"
        :value="profile.employee_account.personal_notification_settings.idle_conversation_threshold_in_minutes + ' min'"
        disabled
    />

    <v-text-field
        label="Save notifications received during do not disturb times for later"
        :value="profile.employee_account.personal_notification_settings.save_notifications_during_dnd_for_later == true ? 'Yes' : 'No' "
        disabled
    />


    <div 
        style="text-align: right; margin-top: 5px;"
        v-show="can_write"
    >
        <v-btn 
            class="mx-2" fab dark small color="primary"
            v-on:click="onEditSounds"
        >
            <v-icon dark> mdi-lead-pencil</v-icon>
        </v-btn>
    </div>

    <m-edit-sound-dialog
        ref="edit_alert_sound"
        v-on:ok="onPatchEmployeeAccount"
    />

</div>
</template>

<script>

const Validation = require('@/js/validate.js');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    methods: {

        onEditSounds()
        {
            this.$refs['edit_alert_sound'].showDialog(this.profile);
        },

        onPatchEmployeeAccount(changes)
        {
            this.$emit('patch-employee-account',changes);
        },
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write; 
        },

        alert_sound_label() 
        {

            let ret = this.profile.extended_data.alert_sound_label;

            if ( ret == null )
                ret = 'No sound will play';

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>